import { useRouter } from "next/router"
import Head from "next/head"
import Link from "next/link"
import { useEffect, useState } from "react"
import { faChevronLeft, faShareAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Typography from "@material-ui/core/Typography"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import { MojeHeader } from "../../components/header/MojeHeader"
import { CenteredPageWrapper } from "../../components/page/centered-page-wrapper"
import { useAuthContext } from "../../modules/auth/authContext"
import { useReservationContext } from "../../modules/reservations/reservationContext"
import { ReservationPopup } from "../../modules/reservations/ReservationPopup"
import { VenueSectionAbout } from "../../modules/miejsca/widgets/VenueSectionAbout"
import { VenueSectionPhotos } from "../../modules/miejsca/widgets/VenueSectionPhotos"
import { VenueSectionProducts } from "../../modules/miejsca/widgets/VenueSectionProducts"
import VenueRightCard from "../../modules/miejsca/widgets/VenueRightCard"

import { BottomBookingBar } from "../../components/header/BottomBookingBar"
import { MojeFooter } from "../../components/MojeFooter"
import { VenueBookmarkIcon } from "../../modules/miejsca/widgets/VenueBookmarkIcon"
import { MojeUrodzinyHead } from "../../components/head/MojeUrodzinyHead"

function VenuePage({ venue }) {
  const router = useRouter()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))
  const authContext = useAuthContext()
  const reservationContext = useReservationContext()
  const [isShowingTimePopup, setIsShowingTimePopup] = useState(false)

  var minPrice =
    venue && venue.products
      ? venue.products.reduce((a, product) => {
          var minProductPrice =
            product && product.pricing
              ? product.pricing.reduce((a, i) => {
                  if (i.price != null) {
                    return a == 0 ? i.price : Math.min(i.price, a)
                  }
                  return a
                }, 0)
              : 0
          if (minProductPrice == 0) {
            return a
          }
          return a == 0 ? minProductPrice : Math.min(a, minProductPrice)
        }, 0)
      : 0

  const handleSelectProduct = (product) => {
    reservationContext.setProduct(product, venue)
    if (!authContext.currentUser) {
      authContext.toggleLoginDialog(true)
      setIsShowingTimePopup(false)
    } else {
      setIsShowingTimePopup(true)
    }
  }
  const handleStartReservation = () => {
    console.log("handleStartReservation")
    if (!authContext.currentUser) {
      authContext.toggleLoginDialog(true)
      setIsShowingTimePopup(false)
    } else {
      setIsShowingTimePopup(true)
    }
  }

  const handleSelectTimeSlot = (date, timeSlot) => {
    reservationContext.updateReservation({
      reservationDate: date,
      reservationTime: timeSlot?.from,
      venue: venue,
    })

    const newReservationUrl = reservationContext.getNewReservationUrl()
    if (newReservationUrl) router.push(newReservationUrl)
  }

  useEffect(() => {
    if (
      reservationContext.reservation?.product &&
      authContext.currentUser &&
      !isShowingTimePopup
    ) {
      // Why is that THEW?
      // setIsShowingTimePopup(true)
    }
  })

  const renderContacts = () => {
    return (
      <div className="flex flex-col">
        {venue.address && <div>{venue.address}</div>}
        {venue.email && <div>{venue.email}</div>}
        {venue.phone && <div>{venue.phone}</div>}
        {venue.phone && <div>{venue.phone}</div>}
      </div>
    )
  }
  return (
    <div>
      <Head>
        <title>{venue?.name}</title>
        <MojeUrodzinyHead
          // url=`{venue?.id}`
          image={
            venue?.media && venue.media.length > 0
              ? venue.media[0].url
              : undefined
          }
          title={`${venue?.name} | na MojeUrodziny.pl`}
        />
      </Head>
      <MojeHeader venueMode showSearch scrollable />
      <CenteredPageWrapper component="main">
        <div className="py-4">
          <Link href="/miejsca" passHref>
            <a className="inline-block font-serif font-medium px-6 py-3 rounded-full border border-gray-200">
              <FontAwesomeIcon className="mr-2" icon={faChevronLeft} />
              Powrót
            </a>
          </Link>
        </div>
        <BottomBookingBar
          venue={venue}
          onShowCalendar={() => {
            setIsShowingTimePopup(true)
            reservationContext.setProduct(undefined)
          }}
          minPrice={minPrice}
        />
        {venue && (
          <>
            <div className="relative mb-4">
              <div className="py-4 flex justify-between items-center">
                <Typography variant="h3" component="h1">
                  {venue.name}
                </Typography>
                <div className="flex gap-2 md:static absolute bottom-2 right-2 z-10">
                  <button
                    className="w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center focus:outline-none"
                    aria-label="share"
                    onClick={() => {
                      // @ts-ignore
                      FB.ui(
                        {
                          method: "share",
                          href: window.location.href.toString(),
                        },
                        function (response) {}
                      )
                    }}
                  >
                    <FontAwesomeIcon className="text-xl" icon={faShareAlt} />
                  </button>
                  <button
                    className="w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center focus:outline-none text-xl"
                    aria-label="favorite"
                  >
                    <VenueBookmarkIcon venue={venue} />
                  </button>
                </div>
              </div>
              <VenueSectionPhotos venue={venue} />
            </div>
            <div className="flex flex-wrap md:flex-nowrap">
              <section className="w-full md:w-2/3 md:pr-8">
                <h2 className="text-2xl mb-2 font-semibold">O nas</h2>
                <VenueSectionAbout venue={venue} />
                <div className="block md:hidden">
                  <VenueRightCard
                    venue={venue}
                    onStartReservation={handleStartReservation}
                  />
                </div>
                <hr className="hidden md:block" />
                <div className="mt-2 text-2xl font-semibold">
                  Scenariusze zabaw
                </div>
                <div className="mb-4">
                  <VenueSectionProducts
                    venue={venue}
                    onProductSelected={handleSelectProduct}
                  />
                </div>

                {/* <VenueSectionDetails venue={venue} />
                {isDesktop ? null : (
                  <div className="py-4 bg-gray-300 h-32">
                    <GoogleBannerV />
                  </div>
                )} */}
                <hr className="hidden md:block" />
                {/* <VenueSectionFAQ venue={venue} /> */}
              </section>
              {isDesktop ? (
                <section className="w-full md:w-1/3 mb-2">
                  <VenueRightCard
                    venue={venue}
                    onStartReservation={handleStartReservation}
                  />
                  {/* <div className="py-4 ">
                    <GoogleBannerV />
                  </div> */}
                </section>
              ) : null}
            </div>
          </>
        )}

        {/* <VenueSectionSendQuestion venue={venue} /> */}
        {venue && (
          <ReservationPopup
            isOpen={isShowingTimePopup}
            venue={venue}
            onClose={() => {
              setIsShowingTimePopup(false)
              reservationContext.setProduct(undefined)
            }}
            onSelectTimeSlot={handleSelectTimeSlot}
            onProductSelected={handleSelectProduct}
          />
        )}
      </CenteredPageWrapper>
      <div className="mb-12 sm:mb-0">
        <MojeFooter />
      </div>
    </div>
  )
}

export async function getStaticProps({ params }) {
  const url = process.env.NEXT_PUBLIC_API_URL + `/public/venues/${params.id}`
  let venue
  try {
    const venueData = await fetch(url).then((res) => res.json())
    venue = venueData?.venue ? venueData.venue : venueData
  } catch (err) {
    console.log("Error fetching venue: ", err)
  }

  return {
    props: {
      venue,
    },
    revalidate: 60, // In seconds
  }
}

export async function getStaticPaths() {
  // const venuesData = await fetch(
  //   process.env.NEXT_PUBLIC_API_URL + `/public/venues/`
  // ).then((res) => res.json())

  return {
    paths: [],
    // paths: venuesData.map((venue) => ({
    //   params: {
    //     id: venue.id,
    //   },
    // })),
    fallback: true,
  }
}

export default VenuePage
